import {Action, State} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {AsideService} from '../../services/aside.service';
import {AsideAction} from './aside.actions';

@State({
    name: AsideState.STATE_NAME,
})
@Injectable()
export class AsideState {
    static readonly STATE_NAME = 'aside';

    constructor(private asideService: AsideService) {}

    @Action(AsideAction.Open)
    open(ctx: any, action: AsideAction.Open) {
        return this.asideService.open(action.component);
    }
}
